<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-select v-model='theLogInstance' clearable @change="theLogInstanceChange" size="small" placeholder="选择服务模块">
          <el-option
              v-for="item in theLogInstanceAll"
              :key="item.name"
              :label="item.label"
              :value="item.name" >
          </el-option>
        </el-select>
        <el-input
          v-model="getSysLogList_data.logUserName"
          placeholder="请输入用户名"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-input
          v-model="getSysLogList_data.logIp"
          placeholder="请输入请求ip"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-input
          v-model="getSysLogList_data.logPath"
          placeholder="请输入请求地址"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getSysLogList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable ref="getSysLogList"
      :tableColums='tableColums_getSysLogList'
      api='getSysLogList::logUuid'
      xupdateapi='updateUser'
      :height="H-165" >
      <div slot='silCity' v-if="row.silProvince" slot-scope="{row}">{{row.silProvince +'-'+ row.silCity +'-'+ row.silDistrict  }}</div>
    </mytable>

  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: null,
      theProjectId:"",
      theUserProject:"",
      theLogInstanceAll:[
        {id:1,name:"OPPORTUNITY",label:"OPP业务模块"},
        {id:2,name:"APPCENTER",label:"APP模块"},
        {id:3,name:"INTERVIEW",label:"招聘模块"},
        {id:4,name:"RECEIPT",label:"receipt"},
        {id:5,name:"TRAININGMSG",label:"MSG"},
      ],
      logInstance:"",
      tableColums_getSysLogList: {
        $selection: false,

        logInstance: ['微服务名称',130,],
        logTime: ['请求时间',160,],
        // logMethod: '请求方式',
        // logRawPath: '请求地址',
        logPath: '请求地址',
        // logParams: '请求参数',
        logIp: ['请求ip',120,],
        logUserName: ['请求人员名称',120,],
        logRequestTime: ['请求耗时(ms)',120,],
         silCity: ['ip归属地',320,],
      },

    };
  },

  watch: {
    
  },

  methods: {
    theLogInstanceChange(id){
      this.logInstance=id;
      this.getSysLogList({currentPage:1,logInstance:this.logInstance,projectId:this.theProjectId});
    },
    async multiDelete() {
      const selection = Object.keys(this.$refs.getSysLogList.$MyTableCache);
      if( selection.length === 0 ) return alertWarn('请选择您要删除的数据！');
      if( await this._confirm(`确定要删除这${ length }条日志吗?`) ) {
        console.log(selection.join())
      };
    },
    theProjectAllChange(e){
      this.theProjectId=e;
      this.getSysLogList({projectId:this.theProjectId,logInstance:this.logInstance});
    },
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject==0){
      this.getProjectList({pageSize:0});
    }else{
      this.theProjectId=this.theUserProject;
    }
    this.getSysLogList({projectId:this.theProjectId});
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/data/SysLog.vue